export const CErrorChoresContext = {
    LIST_CHORES:'LIST_CHORES',
    CREATE_CHORE: 'CREATE_CHORE',
    APPROVE_CHORE: 'APPROVE_CHORE',
    PAY_CHORE: 'PAY_CHORE',
    REJECT_CHORE: 'REJECT_CHORE'
} as const;